import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel } from '@angular/material/form-field';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-add-region',
    templateUrl: './modal-add-region.component.html',
    styleUrls: ['./modal-add-region.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatLabel, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalAddRegionComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalAddRegionComponent>>(MatDialogRef);

    public form: FormGroup;
    public formSubmitAttempt: boolean;

    constructor() {}

    // ---------------------------------------------------
    // CREATE FORM
    //
    createForm() {
        this.form = new FormGroup({
            label: new FormControl<string>('', [Validators.required]),
        });
    }

    get label() {
        return this.form.get('label');
    }

    // ---------------------------------------------------
    // SAVE LABEL
    //
    prepareForSave() {
        this.formSubmitAttempt = true;
        if (this.form.valid) {
            const data = {
                label: this.label.value,
            };
            this.dialogRef.close(data);
        }
    }

    // ---------------------------------------------------
    // CANCEL FORM
    //
    public cancelForm() {
        this.formSubmitAttempt = false;
    }

    // ---------------------------------------------------
    // INIT
    //
    ngOnInit() {
        this.createForm();
    }
}
